BtnEventEmitter = function () {};
heir.inherit(BtnEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
BtnEventEmitter.prototype.addListener = function (name, action, listener) {
    AppEventEmitter.prototype.addListener.call(this, (name + '.' + action), listener);
};
// noinspection JSCheckFunctionSignatures
BtnEventEmitter.prototype.emitEvent = function (name, action, args) {
    args = args || {};
    $.extend(args, { e: $('#btn_' + action.split('.')[0] + '_' + name), name: name });
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    AppEventEmitter.prototype.emitEvent.call(this, (name + '.' + action), [ args ]);
};

app.btn = new BtnEventEmitter();
app.btn.REFRESH = 'refresh';
app.btn.PG_PREV = 'pg_prev';
app.btn.PG_NEXT = 'pg_next';
app.btn.PG_PREV_UPDATE = 'pg_prev.update';
app.btn.PG_NEXT_UPDATE = 'pg_next.update';

app.btn.on('*', app.btn.REFRESH, function (btn) {
    app.grid.trigger(btn.e.data('tab') ? btn.e.data('tab') : btn.name, app.grid.UPDATE);
});
app.btn.on('*', app.btn.PG_PREV, function (btn) {
    $('#grid_' + (btn.e.data('tab') ? btn.e.data('tab').replace('.', '_') : btn.name))
        .find('.pagination > li.active').prev(':not(.disabled)').find('a').click();
});
app.btn.on('*', app.btn.PG_NEXT, function (btn) {
    $('#grid_' + (btn.e.data('tab') ? btn.e.data('tab').replace('.', '_') : btn.name))
        .find('.pagination > li.active').next(':not(.disabled)').find('a').click();
});
app.btn.on('*', app.btn.PG_PREV_UPDATE, function (btn) {
    var grid = $('#grid_' + (btn.e.data('tab') ? btn.e.data('tab').replace('.', '_') : btn.name));
    if (grid.length) {
        if (grid.find('.pagination > li.active').prev(':not(:disabled)').text() === '') {
            btn.e.addClass('disabled');
        } else {
            btn.e.removeClass('disabled');
        }
    }
});
app.btn.on('*', app.btn.PG_NEXT_UPDATE, function (btn) {
    var grid = $('#grid_' + (btn.e.data('tab') ? btn.e.data('tab').replace('.', '_') : btn.name));
    if (grid.length) {
        if (grid.find('.pagination > li.active').next(':not(:disabled)').text() === '') {
            btn.e.addClass('disabled');
        } else {
            btn.e.removeClass('disabled');
        }
    }
});
